const shouldLog = process.env.NODE_ENV !== "production";

const log = (...args: unknown[]): void => {
  if (!shouldLog) {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(...args);
};

const info = (...args: unknown[]): void => {
  if (!shouldLog) {
    return;
  }
  // eslint-disable-next-line no-console
  console.info(...args);
};

const warn = (...args: unknown[]): void => {
  if (!shouldLog) {
    return;
  }
  // eslint-disable-next-line no-console
  console.warn(...args);
};

const error = (...args: unknown[]): void => {
  // Always surface errors to make debugging easier
  // eslint-disable-next-line no-console
  console.error(...args);
};

const logger = {
  log,
  info,
  warn,
  error,
};

export default logger;
